module.exports = __webpack_public_path__ + "img/20210912.63936432.gif";